<template>
  <div v-if="toast.message" class="toast-container">
    <div class="toast">
      <div
        :class="toastClass"
      >
        {{ toast.message }}
      </div>
      <div
        class="close"
        @click="clearToasts"
      >
        <svg width="16" height="16" viewBox="0 0 52 51" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="47.5355" y1="3.53553" x2="4.53553" y2="46.5355" stroke="white" stroke-width="10"/>
          <line x1="47.4645" y1="46.5355" x2="4.46446" y2="3.53554" stroke="white" stroke-width="10"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import {NS_LAYER_STATE} from "@/store/constants";

export default {
  name: 'OToast',

  computed: {
    ...mapState(NS_LAYER_STATE, [
      'toast',
    ]),

    toastClass() {
      if(this.toast.variation === 'error') {
        return 'error';
      }

      return 'error';
    }
  },

  watch: {
    toast(toast) {
      if (toast.message) {
        // TODO set time to make error go away.
      }
    }
  },

  methods: {
    ...mapActions(NS_LAYER_STATE, [
      'clearToasts',
    ])
  }
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  z-index: 3;
  bottom: 0;
  margin: 10px;
  width: calc(100% - 20px);
}

.toast {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px;
  box-shadow: 0px 0px 10px #828080;
  border-radius: 5px;
  background: black;
  color: white;
  font-weight: 600;
  line-height: 19px;
}

.close {
  padding-left: 15px;
  cursor: pointer;
}
</style>
